/** @jsxImportSource @emotion/react */
import { faCaretLeft, faCaretRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { useState } from "react";
import {
    Button, FormGroup,
    FormText,
    Label
} from "reactstrap";
import { getDayOptions } from "../Helper/DatePicker";
import { RadioButtons } from "./RadioButton";

export interface DateRadioButtonsProps {
    setValue: (value: string) => void;
    value: string;
    label: string;
    forward: number;
    backward: number;
    disable_future_dates?: boolean;
    description: string;
    disabled?: boolean;
}

export default function DateRadioButtons({ setValue, value, label, forward = 1, backward = 7, disable_future_dates = false, description = "", disabled = false }) {
    const [days, setDays] = useState([backward, forward]);

    const options = getDayOptions(days[0], days[1], disable_future_dates);

    const goBackward = () => {
        setDays([days[0] + 7, days[1] - 7]);
    };

    const goForward = () => {
        setDays([days[0] - 7, days[1] + 7]);
    };
    let formattedValue = value || "";
    if (value) {
        const dayjsValue = dayjs(value);
        if (dayjsValue.isValid()) {
            formattedValue = dayjsValue.format("YYYY-MM-DD");
        }
    }

    return (
        <FormGroup>
            {label && <Label>{label}</Label>}

            {description && <FormText className="d-block">{description}</FormText>}

            <div>
                <RadioButtons
                    name=""
                    color="secondary"
                    className="mb-1 me-1"
                    current={formattedValue}
                    options={options}
                    onChange={(_, new_value) => setValue(new_value)}
                    disabled={disabled}
                />
            </div>

            <div>
                <Button color="link" size="sm" onClick={() => goBackward()} disabled={disabled}><FontAwesomeIcon icon={faCaretLeft} /> Earlier</Button>
                <Button color="link" size="sm" onClick={() => goForward()} disabled={disabled}>Later <FontAwesomeIcon icon={faCaretRight} /></Button>
            </div>
        </FormGroup>
    );
}
